import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const savingAdCopyPatterns = ReducerUtils.createReducer(false,{
  [Actions.SAVING_AD_COPY_PATTERNS] : (state,action)=>action.status,
})

export default savingAdCopyPatterns